import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastService } from 'src/app/core';
import { AuthService } from 'src/app/core/auth.service';
import { Validators, UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { ImmigrationComment, ImmigrationCommentApi } from 'src/app/core/api.gen';
import { finalize } from 'rxjs/operators';
import { CommonService } from 'src/app/core/common.service';
import { LoaderService } from 'src/app/core/loader.service';

@Component({
  selector: 'eos-immigration-comments',
  templateUrl: './immigration-comments.component.html',
  styleUrls: ['./immigration-comments.component.css']
})
export class ImmigrationCommentsComponent implements OnInit {


  @Input() public readonly?: boolean;
  @Input() public commentType: number;
  @Input() public profileId: number;
  @Input() public profileStatusId: number;
  @Input() public IsVisaApprover: boolean;

  editMode = false;
  addclicked = false;
  employeeId: number;
  comments: ImmigrationComment[] = [];

  commentForm = new UntypedFormGroup({
    comment: new UntypedFormControl('', [Validators.required]),
    immigrationProfileId: new UntypedFormControl(null),
    commentType: new UntypedFormControl(null),
    statusId: new UntypedFormControl(null),
    id: new UntypedFormControl(0)
  });

  constructor(
    public modal: NgbActiveModal,
    private toast: ToastService,
    private authService: AuthService,
    private iCApi: ImmigrationCommentApi,
    private common: CommonService,
    private loader: LoaderService
  ) { }

  ngOnInit() {
    this.employeeId = this.authService.ActiveUser.employeeId;
    this.getComments();
    this.setForm();
  }

  getComments() {
    this.iCApi.getComments(this.profileId)
      .subscribe(resp => {
        this.comments = resp;
      });
  }

  get DisableSaveUpdate(): boolean {
    return !this.commentForm.valid || this.readonly || this.addclicked;
  }



  save() {
    if (this.commentForm.value.comment.trim() !== '') {
      this.addclicked = true;
      this.loader.show();
      this.iCApi.save(this.commentForm.getRawValue())
        .pipe(finalize(() => {
          this.loader.clear();
        }))
        .subscribe(resp => {
          this.getComments();
          this.setForm();
          if (!this.editMode) {
            this.toast.success("Successfully saved!");
          } else {
            this.toast.success("Successfully updated!");
          }
          this.editMode = false;
          this.addclicked = false;
        });
    }
  }


  editComment(comm: ImmigrationComment) {
    this.editMode = true;
    this.commentForm.patchValue({
      commentType: comm.commentType,
      statusId: this.profileStatusId,
      immigrationProfileId: this.profileId,
      comment: comm.comment,
      id: comm.id
    });
  }

  setForm() {
    this.commentForm.patchValue({
      commentType: this.commentType,
      statusId: this.profileStatusId,
      immigrationProfileId: this.profileId,
      comment: '',
      id: 0
    });
  }

}
